import React, { PureComponent } from "react";
import moment from "moment-timezone";

import BarChartLegendsStackedSummary from "../../BarChartLegendsStacked/BarChartLegendsStackedSummary";

import { Metric, selectFormat, Error } from "./../../Utils/Utils.js";
import Heading from "../../Elements/Heading";

class VideoSummary extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: [
      {
        Metric: "Views Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.views.yesterday_fb.value,
          "0,0"
        ),
      },
      {
        Metric: "Minutes Watched Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.minutes.yesterday_fb.value,
          "0,0"
        ),
      },
      {
        Metric: "Views 2 Days Ago",
        Value: selectFormat(
          "number",
          this.props.data.views.two_days_ago.value,
          "0,0"
        ),
      },
      {
        Metric: "Minutes Watched 2 Days Ago",
        Value: selectFormat(
          "number",
          this.props.data.minutes.two_days_ago.value,
          "0,0"
        ),
      },
      {
        Metric: "Unique Videos Published Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.videos_count.yesterday.value,
          "0,0"
        ),
      },
    ],
    opts: {
      type: "other",
    },
  });
  render() {
    const { data } = this.props;

    const lastUpdated = moment
      .tz(data.now, data.cutoffTimezone)
      .format("dddd D MMM, HH:SS");
    const cutoffTime = moment
      .tz(data.cutoffTime, data.cutoffTimezone)
      .format("HH:SS");
    const tz = moment.tz(data.cutoffTime, data.cutoffTimezone).zoneAbbr();

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <>
        {lastUpdated && cutoffTime && (
          <Heading size={6} className="mb-4">
            Last updated {lastUpdated} {tz}.
            <br />
            Updated every day at {cutoffTime} {tz}.
          </Heading>
        )}
        <div className="row">
          <div className="col-6">
            <Heading size={6} className={"mb-1"}>
              Views Yesterday
            </Heading>
            <Metric {...data.views.yesterday_fb} size={"lg"} />
            <Heading
              size={6}
              className={"mb-1"}
              icons={data.views.yesterday_fb.networks}
              icons_size={"sm"}
            ></Heading>
          </div>

          <div className="col-6">
            <Heading size={6} className={"mb-1"}>
              Minutes Watched Yesterday
            </Heading>
            <Metric {...data.minutes.yesterday_fb} size={"lg"} />
            <Heading
              size={6}
              className={"mb-1"}
              icons={data.minutes.yesterday_fb.networks}
              icons_size={"sm"}
            ></Heading>
          </div>

          <div className="col-6 mt-3 mb-3">
            <Heading size={6} className={"mb-1"}>
              Views 2 Days Ago
            </Heading>
            <Metric {...data.views.two_days_ago} size={"lg"} />
            <Heading
              size={6}
              className={"mb-1"}
              icons={data.views.two_days_ago.networks}
              icons_size={"sm"}
            ></Heading>
          </div>

          <div className="col-6 mt-3 mb-3">
            <Heading size={6} className={"mb-1"}>
              Minutes Watched 2 Days Ago
            </Heading>
            <Metric {...data.minutes.two_days_ago} size={"lg"} />
            <Heading
              size={6}
              className={"mb-1"}
              icons={data.minutes.two_days_ago.networks}
              icons_size={"sm"}
            ></Heading>
          </div>

          <div className="col-6 mt-3 mb-3">
            <Heading size={6} className={"mb-1"}>
              Video Views By Month
            </Heading>
            <BarChartLegendsStackedSummary
              data={{ data: data.views_by_month, hasData: true }}
            />
          </div>

          {data.videos_count.yesterday && (
            <div className="col-6 mt-3 mb-3">
              <Heading size={6} className={"mb-1"}>
                Unique Videos Published Yesterday
              </Heading>
              <Metric {...data.videos_count.yesterday} size={"lg"} />
              <Heading
                size={6}
                className={"mb-1"}
                icons={data.videos_count.yesterday.networks}
                icons_size={"sm"}
              ></Heading>
              <Heading size={6} className={"mb-1"} icons_size={"sm"}></Heading>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default VideoSummary;
